/**
 * Since we can't pass functions as prop values with Formkit components, we can pass in a string
 * representing a function that is evaluated in this map after the props have been serialized.
 */
export const VALUE_LABEL_FUNCTION_MAP = {
  trimStartASCIIOnly: ({ label }) =>
    label.replace(/[\u{0080}-\u{FFFF}]/gu, "").trimStart(),
};
